import React from 'react';
import Images from '../assets/AllImages';

const PerformanceCards = [
  { image: Images.Performace1 },
  { image: Images.Performace2 },
  { image: Images.Performace3 },
  { image: Images.Performace4 },
];

const RESTURANT = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="restaurant-hero">
        <div className="hero-content text-center">
          <h2 className="mb-2">STEP ARENA HOTEL & RESTAURANT</h2>
          <p className="lead mb-1">Comfort, Energy, and Nutrition — All in One Place</p>
          <p>
            Located at the heart of the Step Arena complex, our hotel offers direct access to our spa,
            Olympic swimming pools, and fitness zones. The quiet environment, high-speed Wi-Fi, and
            professional amenities create the perfect balance between work, leisure, and athletic
            preparation.
          </p>
        </div>
      </section>

      {/* Step Arena Intro (Blue band with collage and white tabs) */}
      <section className="arena-intro-section">
        <div className="container text-center">
          <h2 className="step-heading mb-3">STEP ARENA</h2>
          <div className="collage">
            <img src={Images.NEWS1} alt="Restaurant service" />
            <img src={Images.Frame236} alt="Chef plating" />
            <img src={Images.NEWS8} alt="Dinner ambiance" />
          </div>
          <h3 className="mb-2">HOTEL & RESTAURANT</h3>
          <p className="subheading mb-4">Your Stay, Elevated</p>

          <div className="row g-4 white-feature-row">
            {[
              { text: 'Elegant rooms with premium standards' },
              { text: 'Direct access to wellness & training facilities' },
              { text: 'Conference room for team meetings and workshops' },
              { text: 'Ideal for training camps, international teams, and family visitors' },
            ].map((item, idx) => (
              <div className="col-12 col-sm-6 col-lg-3" key={idx}>
                <div className="feature-card white-tab-card">
                  <img
                    src={PerformanceCards[idx % 4].image}
                    alt=""
                    className="img-fluid my-3"
                  />
                  <p className="text-primary text-center">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Where Performance Meets Nutrition */}
      <div className="container-fluid">
        <div className="row py-5">
          <div className="col-md-8 text-center mx-auto">
            <h4 className="text-primary fw-bold">Where Performance Meets Nutrition</h4>
            <p>
              The Step Arena Restaurant fuels your goals with a carefully crafted menu that blends
              flavor, health, and performance. From high-protein options for athletes to balanced
              meals for families and children, every dish is designed to nourish and energize.
            </p>
            <p>
              Our kitchen sources fresh ingredients and offers tailored nutritional support for
              different dietary needs. Whether you’re recovering after training or enjoying a
              relaxed meal with loved ones, you’ll find the perfect choice in a warm, welcoming
              environment.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="container-fluid p-0 position-relative">
            <div className="container position-absolute start-50 translate-middle-x icon-card">
              <div className="row justify-content-center">
                {PerformanceCards.map((card, i) => (
                  <div
                    key={i}
                    className="col-6 col-md-3 d-flex flex-column align-items-center text-center"
                  >
                    <div className="feature-card w-100 shadow icon-container">
                      <img src={card.image} alt="" className="img-fluid my-3" />
                      <p className="text-primary">Trainer</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <img
              src={Images.PerfBackground}
              alt="Performance and nutrition"
              className="img-fluid w-100"
            />
          </div>
        </div>
      </div>

      {/* Step Spa */}
      <div className="container-fluid" style={{ margin: '20% 0' }}>
        <div className="row py-5">
          <div className="col-md-8 text-center mx-auto">
            <h4 className="text-primary fw-bold">
              Step Spa - Recovery, Relaxation, and Rejuvenation
            </h4>
            <p>
              Step Spa is a serene and purpose-built space within the Step Arena complex, dedicated
              to physical and mental regeneration. Tailored for athletes, wellness-seeking visitors,
              and anyone in need of personal care, it offers the ideal retreat to unwind, recharge,
              and restore balance.
            </p>
            <p>
              Whether you’re an athlete recovering after intensive training, someone healing from an
              injury, or simply looking for a moment of tranquility, Step Spa is designed to support
              your wellbeing with expertise and care.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="container-fluid p-0 position-relative">
            <div className="container position-absolute start-50 translate-middle-x icon-card">
              <div className="row justify-content-center">
                {PerformanceCards.map((card, i) => (
                  <div
                    key={i}
                    className="col-6 col-md-3 d-flex flex-column align-items-center text-center"
                  >
                    <div className="feature-card w-100 shadow icon-container">
                      <img src={card.image} alt="" className="img-fluid my-3" />
                      <p className="text-primary">Trainer</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <img
              src={Images.Relexation}
              alt="Spa and relaxation"
              className="img-fluid w-100"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default RESTURANT;
